import styled from 'styled-components';

export const Container = styled.div`
  .logo img {
    width: 42px;
    height: 42px;
  }
`;
